<template>
  <div>
    <!-- 渠道安全配置新增对话框 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :modal-append-to-body="true" append-to-body
      close-on-click-modal @closed="handleClose">
      <el-form class="channelForm" ref="form" :model="form" :rules="rules" label-width="160px">
        <!-- 渠道选择 单选radio -->
        <el-form-item label="渠道选择：" prop="channel">
          <el-radio-group v-model="form.channel.channelType">
            <el-radio disabled label="0">全部渠道</el-radio>
            <el-radio disabled label="1">指定渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.channel.channelType === '1'" label="">
          <el-input type="textarea" @focus="channelInputClick(item)" v-model="form.channel.channelNames">
          </el-input>
        </el-form-item>
        <!-- 端类型：1-发端 2-收端 -->
        <el-form-item label="端类型" prop="clientType">
          <el-radio-group v-model="form.clientType">
            <el-radio label="1">发端</el-radio>
            <el-radio label="2">收端</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 云桌面检测配置：0-关闭 1-开启-->
        <el-form-item label="云镜像封禁" prop="cloudDeskFlag">
          <el-radio-group v-model="form.cloudDeskFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 云镜像检测配置：0-关闭 1-开启 -->
        <el-form-item label="云镜像检测配置" prop="cloudMirrorFlag">
          <el-radio-group v-model="form.cloudMirrorFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="好友分享检测配置" prop="friendShareFlag">
          <el-radio-group v-model="form.friendShareFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 局域网镜像检测配置：0-关闭 1-开启 -->
        <el-form-item label="局域网镜像检测配置" prop="lanMirrorFlag">
          <el-radio-group v-model="form.lanMirrorFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 本地音频检测配置：0-关闭 1-开启 -->
        <el-form-item label="本地音频检测配置" prop="localAudioFlag">
          <el-radio-group v-model="form.localAudioFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 本地图片检测配置：0-关闭 1-开启 -->
        <el-form-item label="本地图片检测配置" prop="localPicFlag">
          <el-radio-group v-model="form.localPicFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 	本地视频检测配置：0-关闭 1-开启 -->
        <el-form-item label="本地视频检测配置" prop="localVideoFlag">
          <el-radio-group v-model="form.localVideoFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 	在线音频检测配置：0-关闭 1-开启 -->
        <el-form-item label="在线音频检测配置" prop="onlineAudioFlag">
          <el-radio-group v-model="form.onlineAudioFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 在线图片检测配置：0-关闭 1-开启 -->
        <el-form-item label="在线图片检测配置" prop="onlinePicFlag">
          <el-radio-group v-model="form.onlinePicFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 在线视频检测配置 0-关闭 1-开启 -->
        <el-form-item label="在线视频检测配置" prop="onlineVideoFlag">
          <el-radio-group v-model="form.onlineVideoFlag">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 在线视频域名策略：R1 R2 R3 -->
        <el-form-item label="在线视频域名策略" prop="onlineVideoDomainStrategy">
          <el-radio-group v-model="form.onlineVideoDomainStrategy">
            <el-radio label="R1" style="margin-right: 45px;">R1</el-radio>
            <el-radio label="R2" style="margin-right: 45px;">R2</el-radio>
            <el-radio label="R3">R3</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input show-word-limit maxlength="9999" type="textarea" size="small" v-model="form.remark"
            placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
      <!-- 保存和取消 -->
      <div class="btn-container" style="text-align: right; margin-top: 20px">
        <el-button size="small" type="primary" @click="save">保存</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <channel-popups :isAppendToBody="true" :modelIsAppendToBody="false" :app-id="form.channel.channelIds"
      :visible.sync="channelVisible" @comfirm="channelConfirm($event, item)" :multiple="true"></channel-popups>
  </div>
</template>

<script>
import _ from 'lodash'
import { addChannelConfig, editChannelConfig } from '@/api/security/channelConfig'
import Message from '@/components/Message'
import ChannelPopups from "@/components/channel-popups";
export default {
  name: 'WebSaaSAdd',
  inject: ['loadList'],
  components: {
    ChannelPopups
  },
  computed: {
    title() {
      return this.optionType === 'add' ? '新增' : '编辑';
    },
  },
  data() {
    return {
      /** 渠道选择框 */
      channelVisible: false,
      /** 操作类型 */
      optionType: 'add',
      /** 对话框显隐 */
      dialogVisible: false,
      /** 表单 */
      form: {
        /** 渠道配置 */
        channel: {
          /** 渠道类型 */
          channelType: '1',
          /** 渠道id */
          channelIds: '',
          /** 渠道名称 */
          channelNames: '',
        },
        /** 渠道ids */
        channelIds: [],
        /** 渠道名称 */
        channelNames: [],
        /** 端类型 */
        clientType: '1',
        /** 云桌面检测配置 */
        cloudDeskFlag: '0',
        /** 云镜像检测配置 */
        cloudMirrorFlag: '0',
        /** 好友分享检查配置 */
        friendShareFlag: '0',
        /** 局域网镜像检测配置 */
        lanMirrorFlag: '0',
        /** 本地音频检测配置 */
        localAudioFlag: '0',
        /** 本地图片检测配置 */
        localPicFlag: '0',
        /** 本地视频检测配置 */
        localVideoFlag: '0',
        /** 在线音频检测配置 */
        onlineAudioFlag: '0',
        /** 在线图片检测配置 */
        onlinePicFlag: '0',
        /** 在线视频域名策略 */
        onlineVideoDomainStrategy: 'R1',
        /** 在线视频检测配置 */
        onlineVideoFlag: '0',
        /** 备注 */
        remark: '',
      },
      /** 表单验证规则 */
      rules: {
        /** 渠道选择 */
        channel: [
          {
            required: true, trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.form.channel.channelIds) {
                callback(new Error('请选择渠道'));
              } else {
                callback();
              }
            },
          },
        ],
        /** 端类型 */
        clientType: [
          { required: true, message: '请选择端类型', trigger: 'change' },
        ],
        /** 云桌面检测配置 */
        cloudDeskFlag: [
          { required: true, message: '请选择云桌面检测配置', trigger: 'change' },
        ],
        /** 云镜像检测配置 */
        cloudMirrorFlag: [
          { required: true, message: '请选择云镜像检测配置', trigger: 'change' },
        ],
        /** 好友分享检查配置 */
        friendShareFlag: [
          { required: true, message: '请选择好友分享检查配置', trigger: 'change' },
        ],
        /** 局域网镜像检测配置 */
        lanMirrorFlag: [
          { required: true, message: '请选择局域网镜像检测配置', trigger: 'change' },
        ],
        /** 本地音频检测配置 */
        localAudioFlag: [
          { required: true, message: '请选择本地音频检测配置', trigger: 'change' },
        ],
        /** 本地图片检测配置 */
        localPicFlag: [
          { required: true, message: '请选择本地图片检测配置', trigger: 'change' },
        ],
        /** 本地视频检测配置 */
        localVideoFlag: [
          { required: true, message: '请选择本地视频检测配置', trigger: 'change' },
        ],
        /** 在线音频检测配置 */
        onlineAudioFlag: [
          { required: true, message: '请选择在线音频检测配置', trigger: 'change' },
        ],
        /** 在线图片检测配置 */
        onlinePicFlag: [
          { required: true, message: '请选择在线图片检测配置', trigger: 'change' },
        ],
        /** 在线视频域名策略 */
        onlineVideoDomainStrategy: [
          { required: true, message: '请选择在线视频域名策略', trigger: 'change' },
        ],
        /** 在线视频检测配置 */
        onlineVideoFlag: [
          { required: true, message: '请选择在线视频检测配置', trigger: 'change' },
        ],
      },
    };
  },

  methods: {
    /** 取消 */
    cancel() {
      this.hide();
    },
    /** 保存 */
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.optionType === 'add') {
            this.add()
          } else {
            this.edit()
          }
        }
      });
    },
    /** 新增 */
    async add() {
      const params = _.cloneDeep(this.form)
      const { data } = await addChannelConfig(params)
      if (data.code === 200) {
        Message.success('新增成功')
        this.hide()
        this.loadList()
      }
    },
    /** 编辑 */
    async edit() {
      const params = _.cloneDeep(this.form)
      const { data } = await editChannelConfig(params)
      if (data.code === 200) {
        Message.success('编辑成功')
        this.hide()
        this.loadList()
      }
    },
    /** 点击渠道选择框 */
    channelInputClick(item) {
      console.log("点击渠道选择框", item);
      this.channelVisible = true;
    },
    /** 确认渠道选择 */
    channelConfirm($event, item) {
      console.log("渠道选择的数据", $event, item);
      const { appId, nameStr } = $event;
      this.form.channel.channelIds = appId;
      const idAry = appId.split(",");
      const nameAry = nameStr.split(",");
      this.form.channelIds = idAry
      this.form.channelNames = nameAry
      this.form.channel.channelNames = idAry.map((item, index) => {
        return `[${item}] ${nameAry[index]}`;
      });
    },
    //^ ^--------------对话框自身的方法-------------^ ^
    show(optionType, row) {
      this.optionType = optionType || 'add'
      if (row) {
        this.form = { ...row };
        this.form.channel = {
          channelType: '1',
          channelIds: row.channelId,
          channelNames: `[${row.channelId}] ${row.channelName}`
        }
        this.form.channelIds = row.channelId.split(',')
        this.form.channelNames = row.channelName.split(',')
      }
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      this.form = {
        /** 渠道配置 */
        channel: {
          /** 渠道类型 */
          channelType: '1',
          /** 渠道id */
          channelIds: '',
          /** 渠道名称 */
          channelNames: '',
        },
        /** 渠道ids */
        channelIds: [],
        /** 渠道名称 */
        channelNames: [],
        /** 端类型 */
        clientType: '1',
        /** 云桌面检测配置 */
        cloudDeskFlag: '0',
        /** 云镜像检测配置 */
        cloudMirrorFlag: '0',
        /** 好友分享检查配置 */
        friendShareFlag: '0',
        /** 局域网镜像检测配置 */
        lanMirrorFlag: '0',
        /** 本地音频检测配置 */
        localAudioFlag: '0',
        /** 本地图片检测配置 */
        localPicFlag: '0',
        /** 本地视频检测配置 */
        localVideoFlag: '0',
        /** 在线音频检测配置 */
        onlineAudioFlag: '0',
        /** 在线图片检测配置 */
        onlinePicFlag: '0',
        /** 在线视频域名策略 */
        onlineVideoDomainStrategy: 'R1',
        /** 在线视频检测配置 */
        onlineVideoFlag: '0',
        /** 备注 */
        remark: '',
      }
      /** 清空表单验证规则 */
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  min-height: 70px !important;
}

.channelForm {
  ::v-deep .el-form-item {
    display: flex;
    align-items: center;

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
      display: flex;

      .el-radio-group {
        flex: 1;
        display: flex;

        .left {
          flex: 1;
        }

        .right {
          flex: 1;
        }
      }
    }
  }
}
</style>
